import RestApiModel from "@/api/Model/RestApiModel";
import api from "@/api";

class CommercialClaim extends RestApiModel {
  static getResourceEndpoint() {
    return '/commercial-claims';
  }

  static getDynamicClaimsTypes() {
    return api.get(this.getResourceEndpoint() + '/dynamic-claims-types');
  }

  static listByProducers() {
    return api.get(this.getResourceEndpoint() + '/by-producer');
  }

  static listProducers(params, id, withProducerStatus = false) {
    return api.get(this.getResourceIdEndpoint(id) + '/producers', { params: { withProducerStatus } });
  }

  static assignProducers(producerIds, id) {
    return api.post(this.getResourceIdEndpoint(id) + '/producers', { producerIds });
  }

  static salesCountries() {
    return this.list({endpoint: this.getResourceEndpoint() + '/sales-countries'});
  }

  /**
   * @param id
   * @param isEnabled
   * @returns {*}
   */
  static enable(id, isEnabled) {
    return api.patch(`${this.getResourceIdEndpoint(id)}/enable`, { isEnabled });
  }
}

export default CommercialClaim;
